import { FC, useMemo } from 'react'

import { Modal } from '../Modal'
import { ModalHeader } from 'Components/Modal/ModalHeader'
import { ManageUserInformationForm } from 'Components/Modal/ManageUserInformationModal/ManageUserInformationForm'

import { ModalType, usePeoplePageContext } from 'Contexts/PeoplePageContext'
import { useEmployerUsersContext } from 'Contexts/EmployerUsersContext'

import { MediumBoldText, ThinDarkGreenText } from 'Utils/styles/text'
import { FlexColumn } from 'Utils/styles/spacing'

export const ManageUserInformationModal: FC<{ isJoonAdmin?: boolean }> = ({
  isJoonAdmin = false
}) => {
  const {
    state: { modal, actionableUserId },
    setModal
  } = usePeoplePageContext()

  const {
    state: { users }
  } = useEmployerUsersContext()

  const user = useMemo(() => {
    return users.find((user) => user.id == actionableUserId)
  }, [users, actionableUserId])

  const setShowModal = (show: boolean) =>
    setModal(show ? ModalType.ManageUserInformation : undefined)

  return (
    <Modal showModal={modal === ModalType.ManageUserInformation} setShowModal={setShowModal}>
      <ModalHeader>Manage information</ModalHeader>

      <FlexColumn>
        <MediumBoldText>
          {user?.userInfo.firstName} {user?.userInfo.lastName}
        </MediumBoldText>
        <ThinDarkGreenText>{user?.userInfo.email}</ThinDarkGreenText>
      </FlexColumn>

      <ManageUserInformationForm user={user} isJoonAdmin={isJoonAdmin} />
    </Modal>
  )
}
